import { Box, Button, Skeleton, Typography } from "@mui/material";
import { UserInfo } from "../../types";
import { colors } from "../../theme/palette";
import TrendingCard from "./TrendingCard";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getGoStarRoute } from "../../routers/routeUtils";

const Trending = ({
  icon,
  label,
  users,
  isLoading,
  query,
  sum,
}: {
  icon: JSX.Element;
  label: string;
  users: UserInfo[];
  isLoading: boolean;
  query?: string;
  sum?: boolean;
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "16px",
          borderRadius: "8px",
          border: `1px solid ${colors.Gray100}`,
          background: colors.White,
          width: "300px",
        }}
      >
        {/* Header Skeleton */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "17px",
            paddingBottom: "17px",
            marginBottom: "17px",
            borderBottom: `1px solid ${colors.Gray100}`,
          }}
        >
          {icon}
          <Typography
            variant="body16Bold"
            sx={{
              display: "flex",
              flexDirection: currentLanguage === "ar" ? "row-reverse" : "row",
              gap: "5px",
            }}
          >
            <span>{sum ? t("components.trending.trending_female") : t("components.trending.trending")}</span> {label}
          </Typography>
        </Box>

        {/* User Skeletons */}
        {[...Array(3)].map((_, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "12px",
              columnGap: "12px",
            }}
          >
            <Skeleton variant="circular" width={49} height={49} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
            >
              <Skeleton variant="text" width="80px" height={16} />
              <Box sx={{ display: "flex", columnGap: "15px", width: "100%" }}>
                <Skeleton variant="text" width="35px" height={16} />
                <Skeleton variant="text" width="70px" height={16} />
              </Box>
            </Box>
          </Box>
        ))}

        <Button variant="text-sm" sx={{ borderRadius: "8px" }} onClick={() => navigate(getGoStarRoute(query))}>
          {t("components.trending.seeMore")}
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        borderRadius: "8px",
        border: `1px solid ${colors.Gray100}`,
        background: colors.White,
        width: "300px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "17px",
          paddingBottom: "17px",
          marginBottom: "17px",
          borderBottom: `1px solid ${colors.Gray100}`,
        }}
      >
        {icon}
        <Typography
          variant="body16Bold"
          sx={{
            display: "flex",
            flexDirection: currentLanguage === "ar" ? "row-reverse" : "row",
            gap: "5px",
          }}
        >
          <span>{sum ? t("components.trending.trending_female") : t("components.trending.trending")}</span> {label}
        </Typography>
      </Box>
      {users?.map((user: UserInfo, index: number) => {
        if (index < 3) {
          return <TrendingCard key={user.id} user={user} />;
        }
      })}
      <Button variant="text-sm" sx={{ borderRadius: "8px" }} onClick={() => navigate(getGoStarRoute(query))}>
        {t("components.trending.seeMore")}
      </Button>
    </Box>
  );
};

export default Trending;
